import { render } from "./Clamp.vue?vue&type=template&id=08e7fb0b"
import script from "./Clamp.vue?vue&type=script&lang=js"
export * from "./Clamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__